

































import {Vue, Component} from 'vue-property-decorator';

@Component
export default class NoticeServiceTable extends Vue {}
